import gql from 'graphql-tag';

export default gql`
  mutation deleteModeloNota($idModeloNota: String!) {
    deleteModeloNota(idModeloNota: $idModeloNota) {
      _id
    }
  }
`;
